// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tg-2";
export var chatLink = "_tg-0";
export var chatText = "_tg-1";